export default "__VITE_ASSET__DiCQxwS2__"